<template>
  <!-- <v-snackbar
    v-model="alertaNuevaVenta.estatus"
    right
    top
    vertical
    color="white"
    class="text-center mb-0 pt-2 black--text"
    :timeout="40000"
  > -->
  <transition name="slide-y">
    <v-snackbar
      v-model="alertaNuevaVenta.estatus"
      right
      top
      vertical
      color="transparent"
      class="text-center mb-0 pt-2 halloween-snackbar"
      :timeout="40000"
      @input="handleSnackbarChange"
    >

  	  <v-card class="elevation-0 halloween-card textoPoppins">
        <img :src="telarana" class="corner-web corner-web--tl" alt="" aria-hidden="true">
        <img :src="telarana" class="corner-web corner-web--tr" alt="" aria-hidden="true">

        <div class="halloween-scene" v-if="alertaNuevaVenta.estatus">
          <div class="halloween-mist"></div>

          <div
            v-for="particle in fallingEmojis"
            :key="'fall-' + particle.id"
            class="falling-emoji"
            :style="particle.style"
          >{{ particle.emoji }}</div>

          <div
            v-for="spider in spiders"
            :key="'sp-' + spider.id"
            class="hanging-spider"
            :style="spider.style"
          >
            <span class="spider-thread"></span>
            <span class="spider-body">🕷️</span>
          </div>
        </div>

  	  	<v-card-title primary-title>
  	  		<v-spacer></v-spacer>
  	  		<v-img :src="selectedImage" max-width="270" class="halloween-img"></v-img>
  	  		<v-spacer></v-spacer>
  	  	</v-card-title>
  	  	<v-card-text class="halloween-text text-center text-h6 textoPoppins">
	        <div
	        	v-if="alertaNuevaVenta.mensaje"
	          style="white-space: pre-line"
            class="textoPoppins"
	        >
	          {{ alertaNuevaVenta.mensaje.mensaje }}
	        </div>
  	  	</v-card-text>
  	  </v-card>
      <v-btn
        color="#ff6b1a"
        dark
        absolute
        top
        small
        fab
        right
        @click="alertaNuevaVenta.estatus = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </transition>
</template>
<script>
import axios from 'axios';

	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import { mapGetters, mapActions }  from 'vuex';
  import funcionesExcel        from '@/mixins/funcionesExcel'


	export default {

		components:{
      Alerta,
      carga,
    },


    mixins: [ validarErrores, funcionesExcel ],

		props:[
			'alertaNuevaVenta',
	  ],

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado', 'getEscuela','drawer2','getEstatusLlamada','getNuevosProspectos']),
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      spiders: [],
      fallingEmojis: [],
      telarana: require("@/assets/telarana.jpeg"),

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      motivo: '',
      sonido: null,
      volumen: 0.1,

      images: [
        require("@/assets/jack.png"),
        /*require("@/assets/alegria.gif"),
        require("@/assets/images/navidad/1.png"),
        require("@/assets/images/navidad/2.png"),
        require("@/assets/images/navidad/3.png"),
        require("@/assets/images/navidad/4.png"),
        require("@/assets/images/navidad/5.png"),
        require("@/assets/images/navidad/6.png"),
        require("@/assets/images/navidad/7.png"),
        require("@/assets/images/navidad/8.png"),
        require("@/assets/images/navidad/9.png"),*/
      ],

      selectedImage: null

    }),

    watch: {
      'alertaNuevaVenta.estatus': {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.pickRandomImage()
            this.iniciarHalloweenFX();
            this.reproducirSonido();
          }
        }
      }
    },

    created() {
      this.sonido = document.createElement("audio");
      //this.sonido.src = "/navidad.mp3";
      this.sonido.src = "/caja-venta.mp3";
      this.sonido.setAttribute("preload", "auto");
      this.sonido.setAttribute("controls", "none");
      this.sonido.style.display = "none";
      this.sonido.volume = this.volumen;
      document.body.appendChild(this.sonido);
    },

    beforeDestroy() {
      // Limpieza del elemento de audio cuando el componente se destruye
      if (this.sonido) {
        document.body.removeChild(this.sonido);
        this.sonido = null;
      }
    },

    methods:{

      handleSnackbarChange(value) {
        if (value) {
          this.reproducirSonido();
        }
      },

      reproducirSonido() {
        if (this.sonido) {
          this.sonido.volume = this.volumen;
          this.sonido.play().then(() => {
          }).catch((error) => {
            console.error("Error al reproducir el audio:", error);
          });
        }
      },

      cerrar() {
        if (this.sonido) {
          this.sonido.pause();
          this.sonido.currentTime = 0;
        }
        this.alertaNuevaVenta.estatus = false;
      },

      iniciarHalloweenFX() {
        // Hilos cortos: arañas más arriba
        const positions = [
          { left: '8%', drop: 42 },
          { left: '22%', drop: 58 },
          { left: '82%', drop: 80 },
          { left: '88%', drop: 64 },
          { left: '48%', drop: 16 },
        ];
        this.spiders = positions.map((p, i) => ({
          id: i,
          style: {
            left: p.left,
            '--drop': `${p.drop}px`,
            animationDelay: `${0.15 + i * 0.25}s`,
            animationDuration: `${3 + Math.random() * 0.6}s`,
            fontSize: `${22 + Math.random() * 6}px`,
          }
        }));

        const emojis = ['🎃', '🦇', '👻', '✨', '🍬', '🎃', '🦇', '👻'];
        this.fallingEmojis = Array.from({ length: 18 }, (_, i) => {
          const sway = (Math.random() * 36 - 18).toFixed(1);
          return {
            id: i,
            emoji: emojis[i % emojis.length],
            style: {
              left: `${Math.random() * 100}%`,
              fontSize: `${14 + Math.random() * 12}px`,
              animationDelay: `${Math.random() * 2.8}s`,
              animationDuration: `${5.2 + Math.random() * 3}s`,
              '--sway': `${sway}px`,
            }
          };
        });
      },

      pickRandomImage() {
        const index = Math.floor(Math.random() * this.images.length);
        this.selectedImage = this.images[index];
      },

    }
	}
</script>

<style scoped>
  .textoPoppins{
    font-family: 'Poppins', sans-serif !important;
    font-size: 14px;
    font-weight: 400;
  }

  .slide-y-enter-active, .slide-y-leave-active {
    transition: transform 0.5s ease;
  }

  .slide-y-enter, .slide-y-leave-to {
    transform: translateY(100%);
  }

  .halloween-snackbar ::v-deep .v-snack__wrapper {
    background: transparent !important;
    box-shadow: none !important;
    max-width: 560px !important;
    min-width: 520px !important;
    width: 560px !important;
  }

  .halloween-card {
    position: relative;
    z-index: 2;
    width: 100%;
    background: linear-gradient(160deg, #1a0f2e 0%, #2d1450 45%, #1c1028 100%) !important;
    border: 2px solid #ff8a1f;
    border-radius: 4px !important;
    box-shadow:
      0 0 0 1px rgba(255, 138, 31, 0.35),
      0 8px 24px rgba(0, 0, 0, 0.45),
      inset 0 0 40px rgba(255, 120, 20, 0.08);
    overflow: hidden;
  }

  .halloween-text {
    color: #ffe8c8 !important;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
    font-size: 12px !important;
  }

  .halloween-card ::v-deep .v-card__title {
    padding: 40px 10px 0 !important;
    margin-bottom: -8px !important;
  }

  .halloween-card ::v-deep .v-card__text {
    padding: 0 16px 12px !important;
    margin-top: 0 !important;
    position: relative;
    z-index: 2;
  }

  .halloween-img {
    filter: drop-shadow(0 4px 12px rgba(255, 120, 20, 0.35));
    margin-bottom: 0 !important;
  }

  .halloween-img ::v-deep .v-image__image {
    background-position: center 10% !important;
  }

  .halloween-scene {
    position: absolute;
    inset: 0;
    overflow: hidden;
    z-index: 3;
    pointer-events: none;
  }

  .halloween-mist {
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse at 20% 0%, rgba(255, 120, 20, 0.18), transparent 45%),
      radial-gradient(ellipse at 80% 10%, rgba(140, 60, 220, 0.16), transparent 40%);
  }

  .corner-web {
    position: absolute;
    top: 0;
    width: 150px;
    height: auto;
    z-index: 3;
    pointer-events: none;
    opacity: 0.55;
    /* El JPEG es negro sobre blanco: se invierte y se funde para dejar solo los hilos claros */
    filter: invert(1);
    mix-blend-mode: screen;
  }
  .corner-web--tl { left: 0; }
  .corner-web--tr { right: 0; transform: scaleX(-1); }

  .falling-emoji {
    position: absolute;
    top: -12%;
    z-index: 4;
    line-height: 1;
    pointer-events: none;
    animation-name: emoji-fall;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.45));
  }

  .hanging-spider {
    position: absolute;
    top: 0; /* sale del borde superior de la card */
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 5;
    animation: spider-fade-in 0.35s ease both;
  }

  .spider-thread {
    width: 2px;
    height: 0;
    border-radius: 2px;
    transform-origin: top center;
    background: linear-gradient(
      to bottom,
      rgba(255, 230, 180, 0.95),
      rgba(255, 180, 80, 0.75),
      rgba(255, 160, 60, 0.35)
    );
    box-shadow: 0 0 4px rgba(255, 180, 80, 0.6);
    animation: thread-grow 0.9s ease-out forwards;
    animation-delay: inherit;
  }

  .spider-body {
    display: inline-block;
    line-height: 1;
    transform-origin: top center;
    animation: spider-sway 2.4s ease-in-out infinite;
    filter:
      brightness(2.2)
      contrast(1.25)
      drop-shadow(0 0 3px #fff4d0)
      drop-shadow(0 0 8px #ff9a2e)
      drop-shadow(0 2px 4px rgba(0, 0, 0, 0.8));
  }

  @keyframes emoji-fall {
    0% {
      transform: translate3d(0, -20%, 0) rotate(0deg);
      opacity: 0;
    }
    12% { opacity: 1; }
    100% {
      transform: translate3d(var(--sway, 12px), 115vh, 0) rotate(28deg);
      opacity: 0;
    }
  }

  @keyframes spider-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes thread-grow {
    from { height: 0; }
    to { height: var(--drop, 36px); }
  }

  @keyframes spider-sway {
    0%, 100% { transform: rotate(-8deg); }
    50% { transform: rotate(8deg); }
  }
</style>
